import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { getSearchParams } from '../../utils/url';
import ResultsRouter from './ResultsRouter';
import ExploreLeft from './ExploreLeft';
import BuildingSummary from './BuildingSummary/BuildingSummary';

import './ExploreView.css';

const ExploreView = ({ scrollTop }) => {
  useEffect(() => {
    scrollTop();
  });
  const location = useLocation();
  const params = getSearchParams(location.search);
  const hasContext = !!params.bid;
  return (
    <>
      <div className="row grid-container-lg ExploreView">
        <div className="filter">
          <ExploreLeft bid={params.bid} />
        </div>
      </div>
      <div className="row grid-container-lg ExploreView">
        <div className={`results ${!hasContext ? 'no-context' : ''}`}>
          <ResultsRouter />
        </div>
        {hasContext && (
          <div className="context">
            <BuildingSummary bid={params.bid} />
          </div>
        )}
      </div>
    </>
  );
};

ExploreView.propTypes = {
  scrollTop: PropTypes.func.isRequired,
};

export default ExploreView;
